import { render, staticRenderFns } from "./AddStrategyTemplate.vue?vue&type=template&id=15ded384&scoped=true&"
import script from "./AddStrategyTemplate.vue?vue&type=script&lang=js&"
export * from "./AddStrategyTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddStrategyTemplate.vue?vue&type=style&index=0&id=15ded384&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ded384",
  null
  
)

export default component.exports